module.exports = __webpack_public_path__ + "static/sport/loading.19f6dad.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading.gif
// module id = G/2H
// module chunks = 0